import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getSupplierDetails, getSuppliers, getSupplierSettings, GetSuppliersParams } from '../clients/company.api';

export const suppliers = createQueryKeys('suppliers', {
    list: (params: GetSuppliersParams = {}) => ({
        queryKey: [{ params }],
        queryFn: () => getSuppliers(params),
    }),
    comboBoxOptions: (params: GetSuppliersParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOption: (supplierId: string) => ({
        queryKey: [supplierId],
    }),
    detail: (supplierId: string) => ({
        queryKey: [supplierId],
        queryFn: () => getSupplierDetails(supplierId),
        contextQueries: {
            settings: {
                queryKey: null,
                queryFn: () => getSupplierSettings(supplierId),
            },
        },
    }),
});
